module.exports = __webpack_public_path__ + "static/divider10-e42033fad2491a7d0d0a171ee1879c47.svg";